import { Alert } from "@chakra-ui/react";

export interface BlockquoteProps {
  children: any;
}

export const BlockquoteComponent = (props: BlockquoteProps) => {
  const { children } = props;
  return (
    <>
      <Alert
        as="blockquote"
        mt="4"
        status="info"
        variant="left-accent"
        rounded="4px"
        my="1.5rem"
        fontSize="md"
        fontStyle="normal"
        bgColor="orange.100"
        borderLeftColor="orange.400"
      >
        {children}
      </Alert>
    </>
  );
};
